<div class="dashboard-header">
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center gap-2">
      <h5 class="dashboard-title mb-0">Dashboard</h5>
      <div *ngIf="isCompletionFiltered" class="filter-badge-active">
        <span class="filter-tag">
          <i class="fa fa-filter"></i> {{ completionCategoryLabel }}
        </span>
        <button class="filter-clear-btn" (click)="clearCompletionFilter()" title="Clear filter">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    <div class="header-actions">
      <button *ngIf="fromSourcePulse" class="icon-btn" (click)="back()" title="Back to Source Pulse">
        <i class="fa fa-arrow-left"></i>
      </button>
      <button class="icon-btn" (click)="refreshPage()" title="Refresh dashboard data">
        <i class="fa fa-refresh"></i>
      </button>
    </div>
  </div>
</div>

<!-- Stage Tabs -->
<div class="stage-tabs-bar">
  <ul class="nav nav-tabs tab-nav" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link tab-link"
        [class.active]="activeTab === 1"
        (click)="setActiveTab(1)">
        <i class="fa fa-dollar-sign tab-icon tab-icon-costing"></i>
        <span>Costing</span>
        <span class="tab-badge tab-badge-costing">{{ costingData.length }}</span>
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link tab-link"
        [class.active]="activeTab === 2"
        (click)="setActiveTab(2)">
        <i class="fa fa-shopping-cart tab-icon tab-icon-procurement"></i>
        <span>Procurement</span>
        <span class="tab-badge tab-badge-procurement">{{ procurementData.length }}</span>
      </button>
    </li>
  </ul>
</div>

<!-- Filter Bar -->
<div class="filter-bar">
  <div class="filter-bar-left">

    <div class="filter-item position-relative" title="Project Name" style="width: 160px;">
      <input id="projectName" class="filter-input" type="text"
        placeholder="Search Project" [(ngModel)]="selectedProjectName" (input)="filterProjectNames()"
        (focus)="showProjectDropdown = true" (blur)="hideDropdown()" autocomplete="off" />

      <ul class="list-group position-absolute project-dropdown"
        *ngIf="showProjectDropdown && filteredProjectNames.length > 0">
        <li class="list-group-item list-group-item-action project-dropdown-item"
          *ngFor="let name of filteredProjectNames" (mousedown)="selectProjectName(name)" [title]="name">
          {{ name }}
        </li>
      </ul>
    </div>

    <div class="filter-item filter-item-icon" title="Select Customer">
      <i class="fa fa-building filter-item-prefix-icon"></i>
      <select id="customerName" class="filter-select filter-select-icon" aria-label="Select Customer Name"
        [(ngModel)]="selectedCustomerName" (change)="onSelectCustomer()">
        <option disabled value="" [selected]="selectedCustomerName === ''">Customer</option>
        <option *ngFor="let cus of allCustomerData" [value]="cus.customerName">{{ cus.customerName }}</option>
      </select>
    </div>
    <!-- <div class="filter-item filter-item-icon" title="Select Stage">
      <i class="fa fa-layer-group filter-item-prefix-icon"></i>
      <select id="stageFilter" class="filter-select filter-select-icon" aria-label="Select Stage"
        [(ngModel)]="selectedCurrentStage" (change)="onSelectStage($event)">
        <option disabled value="" [selected]="selectedCurrentStage === ''">Stage</option>
        <option value="Costing">Costing</option>
        <option value="Procurement">Procurement</option>
      </select>
    </div> -->

    <button type="button" class="filter-btn filter-btn-ecd" (click)="openModalECD()">
      <i class="fa fa-calendar"></i> ECD
    </button>

    <!-- ECD Modal Popup -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalECD}"
      [ngStyle]="{'display': showModalECD ? 'block' : 'none'}">
      <div class="modal-dialog date-filter-dialog-top" role="document">
        <div class="modal-content date-filter-modal">
          <div class="date-filter-header">
            <div class="date-filter-header-left">
              <div class="date-filter-icon date-filter-icon-ecd">
                <i class="fa fa-calendar-check-o"></i>
              </div>
              <div>
                <div class="date-filter-title">Expected Completion Date</div>
                <div class="date-filter-subtitle">Filter projects by completion date range</div>
              </div>
            </div>
            <button type="button" class="date-filter-close" (click)="closeModalECD()">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="date-filter-body">
            <div class="date-filter-fields">
              <div class="date-filter-field">
                <label for="fromExpectedCompletionDate" class="date-filter-label">
                  <i class="fa fa-arrow-right"></i> From
                </label>
                <input id="fromExpectedCompletionDate" class="date-filter-input" type="date"
                  aria-label="Select Start Expected Completion Date" [(ngModel)]="fromExpectedCompletionDate"
                  (change)="onSelectCompletionDate()" />
              </div>
              <div class="date-filter-field">
                <label for="toExpectedCompletionDate" class="date-filter-label">
                  <i class="fa fa-arrow-left"></i> To
                </label>
                <input id="toExpectedCompletionDate" class="date-filter-input" type="date"
                  aria-label="Select End Expected Completion Date" [(ngModel)]="toExpectedCompletionDate"
                  (change)="onSelectCompletionDate()" />
              </div>
            </div>
          </div>
          <div class="date-filter-footer">
            <button type="button" class="date-filter-btn-reset" (click)="resetDates()">
              <i class="fa fa-undo"></i> Reset
            </button>
            <button type="button" class="date-filter-btn-close" (click)="closeModalECD()">
              <i class="fa fa-times"></i> Close
            </button>
          </div>
        </div>
      </div>
    </div>



    <button type="button" class="filter-btn filter-btn-rfq" (click)="openModalRFQ()">
      <i class="fa fa-calendar"></i> RFQ
    </button>

    <!-- RFQ Date Range Modal Popup -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalRFQ}"
      [ngStyle]="{'display': showModalRFQ ? 'block' : 'none'}">
      <div class="modal-dialog date-filter-dialog-top" role="document">
        <div class="modal-content date-filter-modal">
          <div class="date-filter-header">
            <div class="date-filter-header-left">
              <div class="date-filter-icon date-filter-icon-rfq">
                <i class="fa fa-calendar"></i>
              </div>
              <div>
                <div class="date-filter-title">RFQ Date</div>
                <div class="date-filter-subtitle">Filter projects by RFQ date range</div>
              </div>
            </div>
            <button type="button" class="date-filter-close" (click)="closeModalRFQ()">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="date-filter-body">
            <div class="date-filter-fields">
              <div class="date-filter-field">
                <label for="fromRfqDate" class="date-filter-label">
                  <i class="fa fa-arrow-right"></i> From
                </label>
                <input id="fromRfqDate" class="date-filter-input" type="date" aria-label="Select From RFQ Date"
                  [(ngModel)]="fromRfqDate" (change)="onDateRangeChange()" />
              </div>
              <div class="date-filter-field">
                <label for="toRfqDate" class="date-filter-label">
                  <i class="fa fa-arrow-left"></i> To
                </label>
                <input id="toRfqDate" class="date-filter-input" type="date" aria-label="Select To RFQ Date"
                  [(ngModel)]="toRfqDate" (change)="onDateRangeChange()" />
              </div>
            </div>
          </div>
          <div class="date-filter-footer">
            <button type="button" class="date-filter-btn-reset" (click)="resetRfqDates()">
              <i class="fa fa-undo"></i> Reset
            </button>
            <button type="button" class="date-filter-btn-close" (click)="closeModalRFQ()">
              <i class="fa fa-times"></i> Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <button type="button" class="filter-btn filter-btn-reset" title="Reset fields" (click)="resetFields()">
      <i class="fa fa-undo"></i> Reset
    </button>
  </div>
  <div class="filter-bar-right">
    <button type="button" class="source-pulse-btn" title="Analysis" (click)="onClickAnalysis()">
      <i class="fa fa-line-chart"></i> Source Pulse
    </button>
  </div>
</div>

<!-- Stat Cards -->
<div class="stat-cards-row">
  <div class="stat-card stat-card-open" (click)="onOpenClickedProject('Open')">
    <div class="stat-card-body">
      <div class="stat-card-info">
        <div class="stat-card-number">{{openStatusCount}}</div>
        <div class="stat-card-label">Open Projects</div>
      </div>
      <div class="stat-card-icon">
        <i class="fa fa-folder-open"></i>
      </div>
    </div>
  </div>

  <div class="stat-card stat-card-overdue" (click)="onOverdueClick()">
    <div class="stat-card-body">
      <div class="stat-card-info">
        <div class="stat-card-number">{{overdueCount}}</div>
        <div class="stat-card-label">Over Due</div>
      </div>
      <div class="stat-card-icon">
        <i class="fa fa-clock"></i>
      </div>
    </div>
  </div>

  <div class="stat-card stat-card-month" (click)="onThisMonthClick()">
    <div class="stat-card-body">
      <div class="stat-card-info">
        <div class="stat-card-number">{{ thisMonthProjects?.length || 0 }}</div>
        <div class="stat-card-label">This Month</div>
      </div>
      <div class="stat-card-icon">
        <i class="fa fa-calendar"></i>
      </div>
    </div>
  </div>

  <!-- <div class="stat-card stat-card-risk">
    <div class="stat-card-body">
      <div class="stat-card-info">
        <div class="stat-card-number">10</div>
        <div class="stat-card-label">High Risk Parts</div>
      </div>
      <div class="stat-card-icon">
        <i class="fa fa-exclamation-triangle"></i>
      </div>
    </div>
  </div> -->
</div>

<div *ngIf="loading" class="loading-state">
  <div class="loading-spinner">
    <i class="fa fa-spinner fa-spin"></i>
    <span>Loading data...</span>
  </div>
</div>

<div *ngIf="!loading && matchedCustomerData.length === 0" class="empty-state">
  <i class="fa fa-inbox"></i>
  <p>No data found.</p>
</div>

<!-- Approval Modal Popup -->
<div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showApprovalModal}"
  [ngStyle]="{'display': showApprovalModal ? 'block' : 'none'}">
  <div class="modal-dialog" role="document" style="max-width: 500px;">
    <div class="modal-content date-filter-modal">
      <div class="date-filter-header">
        <div class="date-filter-header-left">
          <div class="date-filter-icon" style="background: linear-gradient(135deg, #10b981, #059669);">
            <i class="fa fa-check-circle"></i>
          </div>
          <div>
            <div class="date-filter-title">Approval Status</div>
            <div class="date-filter-subtitle">{{ selectedApprovalProject?.approval_status }}</div>
          </div>
        </div>
        <button type="button" class="date-filter-close" (click)="closeApprovalModal()">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div class="date-filter-body">
        <div style="margin-bottom: 12px;">
          <label style="font-weight: 600; color: #475569; margin-bottom: 8px; display: block;">Project Details</label>
          <div style="background: #f8fafc; padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0; margin-bottom: 12px;">
            <p style="margin: 4px 0; font-size: 13px;"><strong>Project:</strong> {{ selectedApprovalProject?.projectName }}</p>
            <p style="margin: 4px 0; font-size: 13px;"><strong>Version:</strong> {{ selectedApprovalProject?.version_id }}</p>
            <p style="margin: 4px 0; font-size: 13px;"><strong>Status:</strong> {{ selectedApprovalProject?.approval_status }}</p>
          </div>
          
          <label for="approvalStatusSelect" style="font-weight: 600; color: #475569; margin-bottom: 8px; display: block;">Approval Status</label>
          <select id="approvalStatusSelect" class="form-control" [(ngModel)]="selectedApprovalStatus" style="border-radius: 6px; border: 1px solid #cbd5e1; padding: 8px; width: 100%;">
            <option value="Pending - Manager Review">Pending - Manager Review</option>
          </select>
        </div>
      </div>

      <div class="date-filter-footer">
        <button type="button" class="date-filter-btn-close" (click)="closeApprovalModal()">
          <i class="fa fa-times"></i> Cancel
        </button>
        <button type="button" class="addBtn" style="padding: 8px 16px; margin-left: 8px;"
          (click)="submitApprovalRequest()">
          <i class="fa fa-send"></i> Send Approval
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="matchedCustomerData.length > 0" class="row row_mar mt-1">
  <div class="col-12 grid-margin stretch-card col_pad">
    <div class="table-card">
      <!-- Tab Content -->
      <div class="card-body">
      
        <!-- Pagination Controls -->
        <div class="pagination-controls">
          <!-- Left: Rows per page -->
          <div class="pagination-left">
            <span class="pagination-left-label">Show:</span>
            <select id="rowsPerPage" class="rows-per-page" [(ngModel)]="rowsPerPage" (change)="updateTableRowsForTabs()">
              <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
            </select>
            <span class="pagination-left-label">rows</span>
          </div>

          <!-- Right: Pagination Navigation with Row Count -->
          <div class="pagination-right">
            <span class="row-count">Showing {{ getStartIndexForTab() }} to {{ getEndIndexForTab() }} of {{ currentTabData.length }}
              rows</span>
            <div class="pagination-nav">
              <button class="pagination-btn" (click)="previousPage()"
                [disabled]="currentPage === 1"><i class="fa fa-chevron-left" style="font-size: 10px;"></i></button>
              <span class="pagination-page-info">Page {{ currentPage }} of {{ getTotalPagesForTab() }}</span>
              <button class="pagination-btn" (click)="nextPage()"
                [disabled]="currentPage === getTotalPagesForTab()"><i class="fa fa-chevron-right" style="font-size: 10px;"></i></button>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive gd_main_div_mobile">
          <table class="table table-striped custom-hover">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Project Name</th>
                <th>Customer Name</th>
                <th>RFQ Date</th>
                <th>Assigned Date</th>
                <th>E.C.Date</th>
                <th class="text-center">Target L.Time(W)</th>
                <th class="text-center">Ageing</th>
                <th>Progress</th>               
                <th>Upload Status</th>
                <th>Approval Status</th>
                 <th>Project Status</th>
                <!-- <th>Current Stage</th> -->
                <th>Version</th>
              </tr>
            </thead>
            <tbody>

              <tr *ngFor="let group of paginatedData; let i = index; trackBy: trackByCustomer"
                [ngClass]="{'highlighted-row': group?.project_id === highlightedProjectId}">
                <td (click)="onRowSelect(group)">{{ getStartIndexForTab() + i }}</td>
                <td (click)="onRowSelect(group)" title="{{ group?.projectName }}">{{ group?.projectName }}</td>
                <td (click)="onRowSelect(group)" title="{{ group?.customer_name }}">{{ group?.customer_name }}
                </td>
                <td (click)="onRowSelect(group)" class="td_date"
                  title="{{ group?.rfqDate | date: 'dd-MM-yyyy' }}">{{ group?.rfqDate | date: 'dd-MM-yyyy' }}</td>
                <td (click)="onRowSelect(group)" class="td_date"
                  title="{{ group?.assigned_date | date: 'dd-MM-yyyy' }}">{{ group?.assigned_date | date:
                  'dd-MM-yyyy' }}</td>
                <td (click)="onRowSelect(group)" class="td_date"
                  title="{{ group?.selectedVersionData?.expectedCompletionDate | date: 'dd-MM-yyyy' }}">{{
                  group?.selectedVersionData?.expectedCompletionDate | date: 'dd-MM-yyyy' }}</td>
                <td class="text-center" (click)="onRowSelect(group)" title="{{ group?.targetLeadTime }}">{{
                  group?.targetLeadTime
                  }}</td>
                <td class="text-center" (click)="onRowSelect(group)"
                  [title]="calculateAgeing(group?.assigned_date, group?.status, group?.closed_date)"
                  [ngStyle]="{'color': (group.selectedVersionData?.status === 'Open' && isECDGreaterThanToday(group.selectedVersionData?.expectedCompletionDate)) ? 'red' : 'inherit'}">
                  {{ calculateAgeing(group?.assigned_date, group?.status, group?.closed_date) }}
                </td>

                <td>
                  <div class="progress-container" (click)="onRowSelect(group)">
                    <div style="width: 80%; height: 16px; background-color: #f5f5f5; position: relative; border-radius: 10px; overflow: hidden; border: 1px solid #e0e0e0;">

                      <!-- Progress text -->
                      <div style="position: absolute; z-index: 10; width: 100%; text-align: center; font-size: 12px; color: #424242; font-weight: 600; margin-top: -1px; line-height: 16px;">
                        {{ group.selectedVersionData?.progress }}
                      </div>

                      <!-- Progress bar -->
                      <div [ngStyle]="{
          'width': group.selectedVersionData?.progress,
          'height': '100%',
          'background-color': getProgressColor(group.selectedVersionData?.progress),
          'border-radius': '10px',
          'transition': 'width 0.3s ease'
        }">
                      </div>

                    </div>
                  </div>
                </td>

          

                <td *ngIf="!group.selectedVersionData?.newVersion">
                  <ng-container
                    *ngIf="(group.selectedVersionData?.upload_status?.toLowerCase() === 'error' || group.selectedVersionData?.upload_status?.toLowerCase() === 'new') && 
                           (activeTab === 1 && group.selectedVersionData?.version_id === 1); else statusText">
                    <button type="button" class="btn btn-primary btn-sm ml-1 addBtn" title="Add Sourcing List"
                      (click)="uploadSourcingList(uploadFileModal, group.selectedVersionData)">
                      +
                    </button>
                  </ng-container>

                  <ng-template #statusText>
                    <span class="upload-status-text" title="{{group.selectedVersionData?.upload_status}}">
                      {{ (group.selectedVersionData?.upload_status === 'NoPartsFound' || group.selectedVersionData?.upload_status === 'PartialSuccess') ? 'Completed' : group.selectedVersionData?.upload_status }}
                    </span>
                  </ng-template>

                </td>
                <td *ngIf="group.selectedVersionData?.newVersion" (click)="onRowSelect(group)" title="{{group.selectedVersionData?.newVersion}}">In
                  Progress </td>

                <!-- Approval Status Column -->
                <td>
                  <span class="approval-status-text" 
                    [ngStyle]="{'cursor': 'pointer', 'color': '#3b82f6'}"
                    (click)="openApprovalModal(group)"
                    title="{{group.selectedVersionData?.approval_status || 'No Status'}}">
                    {{ group.selectedVersionData?.approval_status || '-' }}
                  </span>
                </td>

                <!-- <td (click)="onRowSelect(group)" title="{{group?.selectedVersionData?.currentstage}}">
                  <span [ngStyle]="{
    'color': group.selectedVersionData?.currentstage === 'Costing' ? '#1e90ff' : 
              group.selectedVersionData?.currentstage === 'Procurement' ? '#ff4500' : 'inherit'
  }">
                    {{ group?.selectedVersionData?.currentstage }}
                  </span>
                </td> -->
      <td>
                  <span [ngStyle]="{
    'color': (group.selectedVersionData?.status === 'Open') ? '#FFA500' : 
             (group.selectedVersionData?.status === 'Closed') ? '#e23328' : 'inherit'
  }">
                    {{ group.selectedVersionData?.status }}
                  </span>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <!-- Costing Tab: Show version_id -->
                    <ng-container *ngIf="activeTab === 1">
                      <ng-container *ngIf="!group.selectedVersionData?.isAddingNewVersion">
                        <select class="form-select form-select-sm version-dropdown"
                          [(ngModel)]="group.selectedVersionData.version_id"
                          (change)="onVersionChange($event, group)"
                          title="Version number">
                          <option *ngFor="let version_id of group.versions" [value]="version_id">
                            {{ version_id }}
                          </option>
                        </select>

                        <button *ngIf="!isRestrictedStatus(group.selectedVersionData?.approval_status)" type="button"
                          class="btn btn-sm btn-primary addBtn ms-1"
                          (click)="openVersionChoicePopup(versionChoiceModal, group.selectedVersionData)"
                          title="Add new version number">
                          +
                        </button>

                      </ng-container>
                      <ng-container *ngIf="group.selectedVersionData?.isAddingNewVersion">
                        <input type="number" class="form-control form-control-sm version-dropdown"
                          [(ngModel)]="group.selectedVersionData.newVersion" readonly />
                        <button type="button" class="btn btn-sm btn-primary addBtn"
                          (click)="saveNewVersion(group.selectedVersionData)">✔</button>
                        <button type="button" class="btn btn-sm btn-danger"
                          (click)="cancelNewVersion(group.selectedVersionData)">✖</button>
                      </ng-container>
                    </ng-container>

                    <!-- Procurement Tab: Show procurement versions -->
                    <ng-container *ngIf="activeTab === 2">
                      <ng-container *ngIf="!group.selectedVersionData?.isAddingNewVersion">
                        <select class="form-select form-select-sm version-dropdown"
                          [(ngModel)]="group.selectedVersionData.procurement_version_id"
                          (change)="onProcurementVersionChange($event, group)"
                          title="Procurement Version number">
                          <option *ngFor="let procVersion of group.procurementVersions" [value]="procVersion">
                            {{ procVersion }}
                          </option>
                        </select>
                        <button *ngIf="!isRestrictedStatus(group.selectedVersionData?.approval_status)" type="button"
                          class="btn btn-sm btn-primary addBtn ms-1"
                          (click)="openVersionChoicePopup(versionChoiceModal, group.selectedVersionData)"
                          title="Add new procurement version">
                          +
                        </button>

                      </ng-container>
                      <ng-container *ngIf="group.selectedVersionData?.isAddingNewVersion">
                        <input type="number" class="form-control form-control-sm version-dropdown"
                          [(ngModel)]="group.selectedVersionData.newVersion" readonly />
                        <button type="button" class="btn btn-sm btn-primary addBtn"
                          (click)="saveNewVersion(group.selectedVersionData)">✔</button>
                        <button type="button" class="btn btn-sm btn-danger"
                          (click)="cancelNewVersion(group.selectedVersionData)">✖</button>
                      </ng-container>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="paginatedData.length === 0 && currentTabData.length === 0" class="tab-empty-state">
          <i class="fa fa-info-circle"></i>
          <span>No projects found in the {{ activeTab === 1 ? 'Costing' : 'Procurement' }} stage.</span>
        </div>

        <ng-template #versionChoiceModal let-modal>
          <div class="modal-header d-flex align-items-center justify-content-between gap-3">
            <div>
              <h6 class="modal-title mb-0">Duplicate Version Creation</h6>
              <!-- <small class="text-muted">Confirm how you want to update the current version.</small> -->
            </div>
            <button type="button" class="close" (click)="modal.dismiss()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center py-4">
            <p class="mb-2 fw-semibold">Do you really want to clone the version ?

</p>
            <p class="mb-4 text-muted small">Note : Use cloning to duplicate the current version before making changes to ensure no data is lost.
</p>

            <div class="d-flex justify-content-center flex-wrap" style="gap: 40px;">
              <button class="btn btn-outline-primary btn-sm px-4 me-2"
                (click)="chooseNewVersion(); modal.close()">
             Create
              </button>
              <button type="button" class="btn btn-outline-secondary btn-sm px-4"
                (click)="modal.dismiss()">
                Cancel
              </button>
            </div>
          </div>
        </ng-template>

      </div>
    </div>
  </div>
</div>

<div *ngIf="sourceListData.length > 0 || avdData.length > 0">
  <div *ngIf="matchedCustomerData.length > 0">
    <div class="row row_mar mt-1" *ngIf="finalDataList.length === 0">
      <div class="col-12 grid-margin stretch-card col_pad">
        <div class="card">
          <div class="card-header text-white d-flex justify-content-between align-items-center">
            <h6 class="card-title mb-0">Sourcing List Details</h6>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Sl No.</th>
                    <th>Customer Part Number</th>
                    <th>Internal Part Number</th>
                    <th>Description</th>
                    <th>Specification</th>
                    <th>Commodity</th>
                    <th>Manufacturer(Mfg)</th>
                    <th>UOM</th>
                    <th>Project Quantity</th>
                    <th>I-Sourcing</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of sourceListData">
                    <td>{{ item.SlNo }}</td>
                    <td>{{ item.customerPartNumber }}</td>
                    <td>{{ item.internalPartNo }}</td>
                    <td>{{ item.description }}</td>
                    <td>{{ item.specification }}</td>
                    <td>{{ item.commodity }}</td>
                    <td>{{ item.manufacturer }}</td>
                    <td>{{ item.uom }}</td>
                    <td>{{ item.projectQty }}</td>
                    <td>{{ item.iSourcing }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="finalDataList.length === 0" class="row row_mar mt-1">
      <div class="col-12 grid-margin stretch-card col_pad">
        <div class="card">
          <div class="card-header text-white d-flex justify-content-between align-items-center">
            <h6 class="card-title mb-0">Alternate Vendor List Details</h6>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Internal Part No.</th>
                    <th>Manufacturer(Mfg)</th>
                    <th>Specification</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let avditem of avdData">
                    <td>{{ avditem.internalPartNo }}</td>
                    <td>{{ avditem.manufacturer }}</td>
                    <td>{{ avditem.specification }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<div *ngIf="finalDataList.length > 0" class="row row_mar">
  <div class="col-12 grid-margin stretch-card col_pad">
    <div class="card">
      <div class="card-header d-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <h6 class="card-title">Preview</h6>
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn btn-light btn-sm" title="Export as Excel" (click)="exportData()">
            <i class="fas fa-file-export"></i> Export
          </button>
          <button type="button" class="btn btn-outline-primary btn-sm" title="Reset Final data"
            (click)="resetFinalData()">Reset</button>
          <button type="button" class="btn btn-outline-primary btn-sm" title="Reset Final data"
            (click)="selectCriteria(criteriaModal)">Criteria</button>

          <button type="button" class="btn btn-outline-primary btn-sm" title="Upload data" [disabled]="!isUploadEnabled"
            (click)="uploadFinalData()">
            <span *ngIf="isUploading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Upload
          </button>
        </div>
      </div>



      <div class="card-body">
        <div class="table-responsive gd_main_div_mobile">

          <table class="table table-striped custom-hover">
            <thead>
              <tr>
                <th *ngFor="let col of tableHeaders; let i = index">
                  {{ col.label }}
                  <i class="fa fa-chevron-down" (click)="toggleSearch(i)"></i> <!-- Font Awesome Icon -->
                </th>
              </tr>
              <tr *ngIf="showSearch">
                <th *ngFor="let col of tableHeaders; let i = index">
                  <input *ngIf="showSearchRow[i]" type="text" class="form-control form-control-sm"
                    [(ngModel)]="searchValues[i]" (input)="filterData(searchValues[i])"
                    placeholder="Search {{ col.label }}" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of finalDataList; let i=index" [ngClass]="{'not-matched-row': item.showInPayload === false}">
                <td>{{ i+1 }}</td>
                <td> {{ !!item?.customerPartNumber ? item?.customerPartNumber : item?.customerPartNo }}</td>
                <td>{{ item?.internalPartNo }}</td>
                <td>{{ item?.description }}</td>
                <td>{{ item?.specification }}</td>
                <td>{{ item?.commodity }}</td>
                <!-- <td *ngIf="item?.manufacturer">
                  <ng-container>
                    <button *ngIf="!isDropdownVisible[i]" style="font-size: 12px;"
                      [ngClass]="buttonColorMap[item.manufacturer] || 'btn-light'" class="btn btn-mfg ml-1"
                      [ngStyle]="{'border': buttonBorderStyle[i],'width': '150px'}"
                      (click)="toggleDropdownVisibility(item, i); onPreviewManufacturerClick(i)">
                      <span *ngIf="mpnCheckLoading[i]" class="spinner-border spinner-border-sm" role="status"></span>
                      {{ manufacturerOverrideMap[item.manufacturer] || item?.manufacturer }}
                    </button>

                    <select *ngIf="isDropdownVisible[i]"
                      class="form-select form-select-sm manufacturer-dropdown drop-7rem"
                      (change)="onManufacturerChange($event, item, i)" [(ngModel)]="selectedManufacturerMap[i]">
                      <option *ngFor="let manufacturer of allManufacturerDetailsMap[i]" [value]="manufacturer">
                        {{ manufacturer }}
                      </option>
                    </select>

                  </ng-container>
                </td> -->
          
                <td *ngIf="item?.manufacturer">
                  <ng-container>
                    <button *ngIf="!isDropdownVisible[i]" style="font-size: 12px;"
                      [ngClass]="buttonColorMap[item.manufacturer] || 'btn-light'" class="btn btn-mfg ml-1"
                      [ngStyle]="{'border': buttonBorderStyle[i],'width': '150px'}"
                      (click)="toggleDropdownVisibility(item, i)">
                      <span *ngIf="mpnCheckLoading[i]" class="spinner-border spinner-border-sm" role="status"></span>
                      {{ manufacturerOverrideMap[item.manufacturer] || item?.manufacturer }}
                    </button>

                    <select *ngIf="isDropdownVisible[i]"
                      class="form-select form-select-sm manufacturer-dropdown drop-7rem"
                      (change)="onManufacturerChange($event, item, i)" [(ngModel)]="selectedManufacturerMap[i]">
                      <option *ngFor="let manufacturer of allManufacturerDetailsMap[i]" [value]="manufacturer">
                        {{ manufacturer }}
                      </option>
                    </select>

                  </ng-container>
                </td>

                <td>{{ item?.uom }}</td>
                <td>{{ item?.projectQty }}</td>
                <td>
                  <span [style.color]="item?.eol_status === 'Active' ? '#16a34a' : '#dc2626'" 
                        style="font-weight: 600; cursor: pointer; text-decoration: underline;"
                        (click)="openMpnAlternativesModal(i)"
                        title="Click to view alternatives">
                    <span *ngIf="mpnCheckLoading[i]" class="spinner-border spinner-border-sm" role="status"></span>
                    {{ item?.eol_status || '-' }}
                  </span>
                </td>
                <td>{{ item?.eol_confidence }}</td>
                <td>{{ item?.iSourcing }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #customerModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Add Customer</h6>
  </div>
  <div>
    <div class="row">
      <div class="column">
        <label for="firstName">Customer FullName</label>
        <input type="text" id="customerFullName" placeholder="Enter Full Name">
      </div>
      <div class="column">
        <label for="lastName">City</label>
        <input type="text" id="city" placeholder="Enter City">
      </div>
    </div>
    <div class="row">
      <div class="column">
        <label for="state">State</label>
        <input type="text" id="state" placeholder="Enter State">
      </div>
      <div class="column">
        <label for="zip">Country</label>
        <input type="text" id="country" placeholder="Enter Country">
      </div>
    </div>
    <div class="row">
      <div class="column">
        <label for="state">GST Number</label>
        <input type="text" id="gstNumber" placeholder="Enter GST Number">
      </div>
      <div class="column">

      </div>
    </div>
    <!-- </div> -->

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="saveCustomer()">Save</button>
    <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
  </div>
</ng-template>

<ng-template #projectModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Add Project</h6>
  </div>
  <div>

    <div class="row">
      <div class="column">
        <label for="firstName">New Project Name</label>
        <input type="text" id="newProjectName" placeholder="New Project Name">
      </div>
      <div class="column">
        <label for="lastName">Customer Name</label>
        <input type="text" id="lastName" placeholder="Customer Name">
      </div>
    </div>
    <div class="row">
      <div class="column">
        <label for="email">RFQ Date</label>
        <input type="date" id="rfqData" placeholder="RFQ Date">
      </div>
      <div class="column">
        <label for="phone">Expected Completion Date</label>
        <input type="date" id="expectedCompletionDate" placeholder="Expected Completion Date">
      </div>
    </div>
    <div class="row">
      <div class="column">
        <label for="address">Target L. T</label>
        <input type="text" id="targetLT" placeholder="Target L. T">
      </div>
      <div class="column">
        <label for="city"></label>
        <button type="button" class="btn btn-primary btn-sm ml-1" title="Landing Cost"
          (click)="onLandinCost(landinCostModal)">Landing Cost</button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="save()">Save</button>
    <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
  </div>
</ng-template>

<ng-template #landinCostModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Landing Cost</h6>
  </div>
  <div class="modal-body">
    <!-- Q1 -->
    <div class="form-group">
      <label>
        Q-1: Do you want to calculate Landing cost for the project?
      </label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="q1Yes" checked name="q1" (click)="onQn1Change('yes')">
        <label class="form-check-label" for="q1Yes">Yes</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="q1No" name="q1" (click)="onQn1Change('no')">
        <label class="form-check-label" for="q1No">No</label>
      </div>
    </div>

    <!-- Q2 -->
    <div class="form-group" *ngIf="showQn2">
      <label>
        Q-2: Do you want to consider Duties for calculating landing cost?
      </label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="q2Yes" name="q2" (click)="onQn2Change('yes')">
        <label class="form-check-label" for="q2Yes">Yes</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="q2No" name="q2" (click)="onQn2Change('no')">
        <label class="form-check-label" for="q2No">No</label>
      </div>
    </div>

    <!-- Q3 -->
    <div class="form-group" *ngIf="showQn3">
      <label>
        Q-3: Is it for Export or for local consumption?
      </label>
      <select class="form-select form-select-lg" (change)="onQn3Change($event.target.value)">
        <option value="">Select</option>
        <option value="export">Export</option>
        <option value="local">Local Consumption</option>
      </select>
    </div>

    <!-- Q4 -->
    <div class="form-group" *ngIf="showQn4">
      <label>
        Q-4: Do you need specific duty to be added?
      </label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="q4Yes" name="q4" (click)="onQn4Change('yes')">
        <label class="form-check-label" for="q4Yes">Yes</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="q4No" name="q4" (click)="onQn4Change('no')">
        <label class="form-check-label" for="q4No">No</label>
      </div>
    </div>

    <!-- Q5 -->
    <div class="form-group" *ngIf="showQn5">
      <label>
        Q-5: Define your generic duty percentage to be considered
      </label>
      <input type="number" class="form-control" placeholder="Enter generic duty percentage">
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="saveLandingCost()">Save</button>
    <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
  </div>
</ng-template>

<ng-template #uploadFileModal let-modal>
  <!-- Header -->
  <div class="upload-modal-header">
    <div class="upload-modal-header-left">
      <div class="upload-modal-icon-wrapper">
        <i class="nb-cloud-upload"></i>
      </div>
      <div>
        <h5 class="upload-modal-title">Upload Files</h5>
        <p class="upload-modal-subtitle">Upload sourcing list & alternate vendor data</p>
      </div>
    </div>
    <button type="button" class="upload-modal-close" aria-label="Close" (click)="closeUploadModal()">
      <i class="nb-close"></i>
    </button>
  </div>

  <!-- Error Banner -->
  <div *ngIf="headerErrorMessage" class="upload-modal-error-banner">
    <div class="upload-modal-error-content">
      <i class="nb-alert" style="font-size: 14px; flex-shrink: 0;"></i>
      <span>{{ headerErrorMessage }}</span>
    </div>
    <button type="button" *ngIf="isHeaderMappingRequired && sourceListData.length > 0"
      class="upload-modal-configure-btn" [disabled]="!sourcingListFileName"
      (click)="openHeaderMappingModal(mappingModal)" title="Open mapping popup">
      <i class="nb-gear" style="font-size: 11px;"></i> Configure
    </button>
  </div>

  <!-- Body -->
  <div class="upload-modal-body">
    <!-- Sourcing List Card -->
    <div class="upload-card" [class.upload-card-filled]="sourcingListFileName">
      <div class="upload-card-header">
        <div class="upload-card-label">
          <div class="upload-card-icon upload-card-icon-sourcing">
            <i class="nb-list"></i>
          </div>
          <div>
            <span class="upload-card-name">Sourcing List</span>
            <span class="upload-card-hint">.xlsx, .xls</span>
          </div>
        </div>
        <a class="upload-sample-link" (click)="sourcingData()" title="Download Sample Sourcing List">
          <i class="nb-arrow-thin-down" style="font-size: 11px;"></i> Sample
        </a>
      </div>
      <div class="upload-drop-zone" (click)="upload_input.click()">
        <div *ngIf="!sourcingListFileName" class="upload-drop-placeholder">
          <i class="nb-cloud-upload" style="font-size: 22px; color: #94a3b8;"></i>
          <span class="upload-drop-text">Click to browse sourcing file</span>
        </div>
        <div *ngIf="sourcingListFileName" class="upload-file-info">
          <div class="upload-file-icon">
            <i class="nb-checkmark" style="color: #10b981; font-size: 14px;"></i>
          </div>
          <div class="upload-file-details">
            <span class="upload-file-name">{{ sourcingListFileName }}</span>
            <span class="upload-file-status">Ready</span>
          </div>
          <button *ngIf="sourceListData.length > 0" type="button" class="upload-clear-btn"
            (click)="$event.stopPropagation(); clearSourcingListFiles()" title="Remove file">
            <i class="nb-close" style="font-size: 10px;"></i>
          </button>
        </div>
      </div>
      <input #upload_input type="file" class="file-input" hidden (change)="uploadSourcingListFiles($event)">
    </div>

    <!-- Mapping Modal (nested template) -->
    <ng-template #mappingModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Please Map The Required Fields</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="uploadedHeaders.length > 0">
          <div *ngFor="let field of tableHeaders" class="form-group row align-items-center mb-2">
            <label class="col-md-4 font-weight-bold">{{ field.label }}</label>
            <div class="col-md-8">
              <select class="form-control" [(ngModel)]="reverseFieldMapping[field.key]" name="{{field.key}}">
                <option [ngValue]="null">-- Select Column from Upload --</option>
                <option *ngFor="let header of uploadedHeaders" [value]="header">
                  {{ header }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary btn-sm mt-2" (click)="modal.dismiss()">Cancel</button>
        <button type="button" class="btn btn-outline-primary btn-sm mt-2" (click)="applyMappedData(); modal.close()">
          Apply Mapping</button>
      </div>
    </ng-template>

    <!-- Alternate Vendor List Card -->
    <div class="upload-card" [class.upload-card-filled]="alternatePartFileName">
      <div class="upload-card-header">
        <div class="upload-card-label">
          <div class="upload-card-icon upload-card-icon-avd">
            <i class="nb-shuffle"></i>
          </div>
          <div>
            <span class="upload-card-name">Alternate Vendor List</span>
            <span class="upload-card-hint">.xlsx, .pdf</span>
          </div>
        </div>
        <a class="upload-sample-link" (click)="alternateData()" title="Download Sample AVD">
          <i class="nb-arrow-thin-down" style="font-size: 11px;"></i> Sample
        </a>
      </div>
      <div class="upload-drop-zone" (click)="upload_file_input.click()">
        <div *ngIf="!alternatePartFileName" class="upload-drop-placeholder">
          <i class="nb-cloud-upload" style="font-size: 22px; color: #94a3b8;"></i>
          <span class="upload-drop-text">Click to browse AVD file</span>
        </div>
        <div *ngIf="alternatePartFileName" class="upload-file-info">
          <div class="upload-file-icon">
            <i class="nb-checkmark" style="color: #10b981; font-size: 14px;"></i>
          </div>
          <div class="upload-file-details">
            <span class="upload-file-name">{{ alternatePartFileName }}</span>
            <span class="upload-file-status">Ready</span>
          </div>
          <button *ngIf="avdData.length > 0" type="button" class="upload-clear-btn"
            (click)="$event.stopPropagation(); clearAvdFiles()" title="Remove file">
            <i class="nb-close" style="font-size: 10px;"></i>
          </button>
        </div>
      </div>
      <input #upload_file_input type="file" accept=".pdf,.xlsx" class="file-input" hidden
        (change)="handleFileUpload($event)">
    </div>
  </div>

  <!-- Footer -->
  <div class="upload-modal-footer">
    <button type="button" class="upload-btn-secondary" (click)="closeUploadModal()">
      Cancel
    </button>

    <button type="button" class="upload-btn-primary" (click)="finalData()" [disabled]="isLoading">
      <i class="nb-shuffle" style="font-size: 13px;" *ngIf="!isLoading"></i>
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"></span>
      Compare Both Files
    </button>

    <button type="button" class="upload-btn-primary" (click)="fetchReleaseList()" [disabled]="isFetchingReleaseList" title="Fetch Released RFQ List from API">
      <i class="fa fa-cloud-download" style="font-size: 13px;" *ngIf="!isFetchingReleaseList"></i>
      <span *ngIf="isFetchingReleaseList" class="spinner-border spinner-border-sm" role="status"></span>
      Get Released List
    </button>

    <button type="button" class="upload-btn-ai" (click)="toggleAiScrubbing()">
      <i class="fa-solid fa-wand-magic-sparkles" style="font-size: 13px;"></i>
      AI Scrubbing
    </button>
  </div>
</ng-template>

<!-- AI Scrubbing Modal (opens on top of Upload Files popup) -->
<ng-template #aiScrubbingModal let-modal>
  <div class="upload-modal-header" style="background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%); border-bottom: 1px solid #c4b5fd;">
    <div class="upload-modal-header-left">
      <div class="upload-modal-icon-wrapper" style="background: linear-gradient(135deg, #7c3aed, #a855f7);">
        <i class="fa-solid fa-wand-magic-sparkles"></i>
      </div>
      <div>
        <h5 class="upload-modal-title">AI Scrubbing</h5>
        <p class="upload-modal-subtitle">Upload multiple source &amp; AVD files for AI processing</p>
      </div>
    </div>
    <button type="button" class="upload-modal-close" aria-label="Close" (click)="closeAiScrubbingModal()">
      <i class="nb-close"></i>
    </button>
  </div>

  <div class="ai-scrub-section" style="border-top: none;">
    <div class="ai-scrub-body">
      <!-- Source Files -->
      <div class="ai-scrub-card">
        <div class="ai-scrub-card-top">
          <div class="ai-scrub-card-label">
            <div class="ai-scrub-icon blue-bg"><i class="fa-solid fa-table-list"></i></div>
            <div>
              <span class="ai-scrub-card-title">Source Files</span>
              <span class="ai-scrub-card-hint">All file types supported</span>
            </div>
          </div>
          <label class="ai-scrub-browse-btn">
            <i class="fa-solid fa-plus" style="font-size: 11px;"></i> Add Files
            <input type="file" multiple hidden (change)="onAiSourceFilesSelected($event)">
          </label>
        </div>
        <div *ngIf="isAiSourceUploading" class="ai-scrub-uploading">
          <span class="spinner-border spinner-border-sm"></span> Uploading...
        </div>
        <div *ngIf="aiSourceFiles.length > 0" class="ai-scrub-file-list">
          <div *ngFor="let file of aiSourceFiles; let i = index" class="ai-scrub-file-item">
            <i class="fa-solid fa-file-excel ai-scrub-file-type-icon green-text"></i>
            <span class="ai-scrub-file-name">{{ file.name }}</span>
            <span class="ai-scrub-file-size">{{ (file.size / 1024).toFixed(0) }} KB</span>
            <button type="button" class="ai-scrub-file-remove" (click)="removeAiSourceFile(i)" title="Remove">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        <div *ngIf="aiSourceUploadedResponses.length > 0" class="ai-scrub-upload-status success">
          <i class="fa-solid fa-circle-check"></i> {{ aiSourceUploadedResponses.length }} file(s) uploaded
        </div>
      </div>

      <!-- AVD Files -->
      <div class="ai-scrub-card">
        <div class="ai-scrub-card-top">
          <div class="ai-scrub-card-label">
            <div class="ai-scrub-icon amber-bg"><i class="fa-solid fa-list-check"></i></div>
            <div>
              <span class="ai-scrub-card-title">AVD Files</span>
              <span class="ai-scrub-card-hint">All file types supported</span>
            </div>
          </div>
          <label class="ai-scrub-browse-btn">
            <i class="fa-solid fa-plus" style="font-size: 11px;"></i> Add Files
            <input type="file" multiple hidden (change)="onAiAvdFilesSelected($event)">
          </label>
        </div>
        <div *ngIf="isAiAvdUploading" class="ai-scrub-uploading">
          <span class="spinner-border spinner-border-sm"></span> Uploading...
        </div>
        <div *ngIf="aiAvdFiles.length > 0" class="ai-scrub-file-list">
          <div *ngFor="let file of aiAvdFiles; let i = index" class="ai-scrub-file-item">
            <i class="fa-solid fa-file ai-scrub-file-type-icon amber-text"></i>
            <span class="ai-scrub-file-name">{{ file.name }}</span>
            <span class="ai-scrub-file-size">{{ (file.size / 1024).toFixed(0) }} KB</span>
            <button type="button" class="ai-scrub-file-remove" (click)="removeAiAvdFile(i)" title="Remove">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        <div *ngIf="aiAvdUploadedResponses.length > 0" class="ai-scrub-upload-status success">
          <i class="fa-solid fa-circle-check"></i> {{ aiAvdUploadedResponses.length }} file(s) uploaded
        </div>
      </div>
    </div>

    <!-- AI Preview Table -->
    <div *ngIf="aiPreviewData.length > 0" class="ai-preview-table-wrap">
      <div class="ai-preview-table-header">
        <i class="fa-solid fa-table"></i>
        <span>Preview — {{ aiPreviewData.length }} rows | Columns: {{ aiPreviewColumns.length }}</span>
      </div>
      <div class="ai-preview-table-scroll">
        <table class="table table-striped custom-hover ai-preview-table">
          <thead>
            <tr>
              <th>#</th>
              <th *ngFor="let col of aiPreviewColumns">{{ col }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of aiPreviewData; let i = index" [ngClass]="{'not-matched-row': row.isNotMatched}">
              <td>{{ i + 1 }}</td>
              <td *ngFor="let col of aiPreviewColumns">
                <ng-container *ngIf="col === 'EOL Status'; else plainCell">
                  <span [style.color]="row[col] === 'Active' ? '#16a34a' : '#dc2626'" style="font-weight: 600;">
                    {{ row[col] }}
                  </span>
                </ng-container>
                <ng-template #plainCell>{{ row[col] }}</ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="upload-modal-footer">
    <button type="button" class="upload-btn-secondary" (click)="closeAiScrubbingModal()">
      <i class="fa-solid fa-arrow-left" style="font-size: 11px;"></i> Back
    </button>
    <button type="button" class="upload-btn-primary" (click)="processAiData()"
      [disabled]="isAiProcessing || (aiSourceUploadedResponses.length === 0 && aiAvdUploadedResponses.length === 0)">
      <span *ngIf="isAiProcessing" class="spinner-border spinner-border-sm" role="status"></span>
      <i *ngIf="!isAiProcessing" class="fa-solid fa-gears" style="font-size: 13px;"></i>
      Process Data
    </button>
  </div>
</ng-template>



<ng-template #criteriaModal let-modal>
  <!-- Header -->
  <div class="criteria-modal-header">
    <div class="criteria-modal-header-left">
      <div class="criteria-modal-icon-wrapper">
        <i class="fas fa-sliders-h"></i>
      </div>
      <div>
        <h5 class="criteria-modal-title">Sourcing Criteria</h5>
        <p class="criteria-modal-subtitle">Configure ranking & filtering preferences</p>
      </div>
    </div>
    <button type="button" class="criteria-modal-close" aria-label="Close" (click)="closeModal()">
      <i class="nb-close"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="criteria-modal-body">
    <div class="criteria-section">
      <div class="criteria-section-label">
        <i class="fas fa-check-double" style="color: #3b82f6; font-size: 13px;"></i>
        <span>Selection Criteria</span>
      </div>
      <div class="criteria-options-grid">
        <label class="criteria-option" [class.criteria-option-active]="criteria.stockAvailability">
          <input type="checkbox" [(ngModel)]="criteria.stockAvailability" hidden />
          <div class="criteria-option-icon" style="background: rgba(16, 185, 129, 0.1);">
            <i class="fas fa-warehouse" style="color: #10b981;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Stock Availability</span>
            <span class="criteria-option-hint">Prefer in-stock parts</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas" [ngClass]="criteria.stockAvailability ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'" style="font-size: 20px;"></i>
          </div>
        </label>

        <label class="criteria-option" [class.criteria-option-active]="criteria.leadTime">
          <input type="checkbox" [(ngModel)]="criteria.leadTime" hidden />
          <div class="criteria-option-icon" style="background: rgba(59, 130, 246, 0.1);">
            <i class="fas fa-shipping-fast" style="color: #3b82f6;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Minimum Lead Time</span>
            <span class="criteria-option-hint">Prioritize faster delivery</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas" [ngClass]="criteria.leadTime ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'" style="font-size: 20px;"></i>
          </div>
        </label>

        <label class="criteria-option" [class.criteria-option-active]="criteria.minimumPrice">
          <input type="checkbox" [(ngModel)]="criteria.minimumPrice" hidden />
          <div class="criteria-option-icon" style="background: rgba(245, 158, 11, 0.1);">
            <i class="fas fa-tags" style="color: #f59e0b;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Minimum Price</span>
            <span class="criteria-option-hint">Rank by lowest cost</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas" [ngClass]="criteria.minimumPrice ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'" style="font-size: 20px;"></i>
          </div>
        </label>

        <label class="criteria-option" [class.criteria-option-active]="criteria.authorisedSuppliers">
          <input type="checkbox" [(ngModel)]="criteria.authorisedSuppliers" hidden />
          <div class="criteria-option-icon" style="background: rgba(124, 58, 237, 0.1);">
            <i class="fas fa-shield-alt" style="color: #7c3aed;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Authorised Suppliers</span>
            <span class="criteria-option-hint">Only verified suppliers</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas" [ngClass]="criteria.authorisedSuppliers ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'" style="font-size: 20px;"></i>
          </div>
        </label>
      </div>
    </div>

    <div class="criteria-section" style="margin-top: 14px;">
      <div class="criteria-section-label">
        <i class="fas fa-user-check" style="color: #7c3aed; font-size: 13px;"></i>
        <span>Supplier Selection</span>
      </div>
      <ng-select [items]="supplierOptions" [(ngModel)]="criteria.selectedSuppliers" [multiple]="true" bindLabel="name"
        bindValue="name" class="custom-supplier-ng-select"
        [placeholder]="criteria.selectedSuppliers?.length ? '' : 'Search and select suppliers...'">
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="custom-supplier-selected">{{ item.name }}</span>
          <i class="mdi mdi-close-circle-outline custom-supplier-clear-icon" (click)="clear(item)"></i>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <!-- Footer -->
  <div class="criteria-modal-footer">
    <button type="button" class="upload-btn-secondary" (click)="closeModal()">
      Cancel
    </button>
    <button type="button" class="upload-btn-primary" (click)="saveModal()">
      <i class="fas fa-save" style="font-size: 12px;"></i>
      Save Criteria
    </button>
  </div>
</ng-template>

<!-- Modal for Uploading -->
<div class="modal fade show d-block" *ngIf="isUploading" id="uploadModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content text-center p-4">
      <div class="modal-body">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <!-- <h6 class="mt-3">Data Uploading, Please wait...</h6> -->
        <h6 class="mt-3">Sourcing in progress, please wait...</h6>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop (optional) -->
<div class="modal-backdrop fade show" *ngIf="isUploading"></div>

<!-- MPN Alternatives Modal -->
<div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showMpnAlternativesModal}"
  [ngStyle]="{'display': showMpnAlternativesModal ? 'block' : 'none', 'z-index': 1060}">
  <div class="modal-dialog" role="document" style="max-width: 900px; margin-top: 8vh;">
    <div class="modal-content date-filter-modal">
      <div class="date-filter-header">
        <div class="date-filter-header-left">
          <div class="date-filter-icon" style="background: linear-gradient(135deg, #7c3aed, #a855f7);">
            <i class="fa fa-microchip"></i>
          </div>
          <div>
            <div class="date-filter-title"> Part Check Result</div>
            <div class="date-filter-subtitle" *ngIf="selectedMpnResult">
              {{ selectedMpnResult.mpn }} — 
              <span [style.color]="selectedMpnResult.eol_status === 'Active' ? '#16a34a' : '#dc2626'" style="font-weight:700;">
                {{ selectedMpnResult.eol_status }}
              </span>
              <span *ngIf="selectedMpnResult.eol_date"> | EOL Date: {{ selectedMpnResult.eol_date }}</span>
            </div>
          </div>
        </div>
        <button type="button" class="date-filter-close" (click)="closeMpnAlternativesModal()">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div class="date-filter-body" style="padding: 0; max-height: 400px; overflow-y: auto;">
        <table class="table table-striped custom-hover" style="margin-bottom: 0;" *ngIf="selectedMpnResult?.alternatives?.length > 0">
          <thead>
            <tr>
              <th>MPN</th>
              <th>Manufacturer</th>
              <th>EOL Status</th>
              <th>EOL Date</th>
              <th>Reason</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let alt of selectedMpnResult.alternatives">
              <td>{{ alt.mpn }}</td>
              <td>{{ alt.manufacturer }}</td>
              <td>
                <span [style.color]="alt.eol_status === 'Active' ? '#16a34a' : '#dc2626'" style="font-weight: 600;">
                  {{ alt.eol_status }}
                </span>
              </td>
              <td>{{ alt.eol_date || '-' }}</td>
              <td style="max-width: 250px; white-space: normal; font-size: 11px;">{{ alt.reason }}</td>
              <td>
                <button class="btn btn-sm btn-primary" style="font-size: 11px; padding: 3px 10px;"
                  (click)="sendAlternativeToPreview(alt)">
                  <i class="fa fa-paper-plane" style="margin-right: 4px;"></i> Send
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="!selectedMpnResult?.alternatives?.length" style="padding: 20px; text-align: center; color: #94a3b8;">
          No alternatives found.
        </div>
      </div>

      <div class="date-filter-footer">
        <button type="button" class="date-filter-btn-close" (click)="closeMpnAlternativesModal()">
          <i class="fa fa-times"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ...existing code... -->
<div class="modal-backdrop fade show" *ngIf="showMpnAlternativesModal" style="z-index: 1055;"></div>

<!-- Transparent Modal with Loading Spinner -->
<div class="modal fade show d-block transparent-modal" *ngIf="isRefresh" id="uploadModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content border-0 bg-transparent text-center">
      <div class="modal-body">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop fade show"></div>

<ng-template #dataPrefModal let-modal>
  <!-- Header -->
  <div class="criteria-modal-header" style="background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%); border-bottom: 1px solid #fed7aa;">
    <div class="criteria-modal-header-left">
      <div class="criteria-modal-icon-wrapper" style="background: linear-gradient(135deg, #f59e0b, #d97706);">
        <i class="fas fa-database"></i>
      </div>
      <div>
        <h5 class="criteria-modal-title">Data Preference</h5>
        <p class="criteria-modal-subtitle">Choose sourcing data sources</p>
      </div>
    </div>
    <button type="button" class="criteria-modal-close" aria-label="Close" (click)="modal.dismiss()">
      <i class="nb-close"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="criteria-modal-body">
    <div class="criteria-section">
      <div class="criteria-section-label">
        <i class="fas fa-layer-group" style="color: #f59e0b; font-size: 13px;"></i>
        <span>Source Type</span>
      </div>
      <div class="criteria-options-grid">
        <label class="criteria-option" [class.criteria-option-active]="dataPreference.includes('nexar')">
          <input type="checkbox" [checked]="dataPreference.includes('nexar')" (change)="onDataPrefChange('nexar', $event.target.checked)" hidden />
          <div class="criteria-option-icon" style="background: rgba(59, 130, 246, 0.1);">
            <i class="fas fa-globe" style="color: #3b82f6;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Consolidator</span>
            <span class="criteria-option-hint">Online marketplace data</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas" [ngClass]="dataPreference.includes('nexar') ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'" style="font-size: 20px;"></i>
          </div>
        </label>

        <label class="criteria-option" [class.criteria-option-active]="dataPreference.includes('vendor')">
          <input type="checkbox" [checked]="dataPreference.includes('vendor')" (change)="onDataPrefChange('vendor', $event.target.checked)" hidden />
          <div class="criteria-option-icon" style="background: rgba(16, 185, 129, 0.1);">
            <i class="fas fa-handshake" style="color: #10b981;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Direct</span>
            <span class="criteria-option-hint">Direct vendor sourcing</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas" [ngClass]="dataPreference.includes('vendor') ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'" style="font-size: 20px;"></i>
          </div>
        </label>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="criteria-modal-footer">
    <button type="button" class="upload-btn-secondary" (click)="modal.dismiss()">
      Cancel
    </button>
    <button type="button" class="upload-btn-primary" (click)="saveDataPreference()">
      <i class="fas fa-save" style="font-size: 12px;"></i>
      Save Preference
    </button>
  </div>
</ng-template>